<form [formGroup]='filterFormGroup'>

  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="col">All Orders ({{totalOrders$|async}})</div>
    <div class="col d-none">
      <div id="supplier"
           class="float-container">
        <select class="custom-select"
                formControlName="service_name">
          <option selected
                  value="">All Services</option>
          <option [value]="service.value"
                  *ngFor="let service of services$|async">{{service.label|titlecase}}</option>
        </select>
      </div>
    </div>
    <div class="col d-none">
      <div id="supplier"
           class="float-container">
        <select class="custom-select"
                formControlName="status">
          <option selected
                  value="">All Statuses</option>
          <option [value]="status"
                  *ngFor="let status of statuses">{{status|titlecase}}
          </option>
        </select>
      </div>
    </div>
    <div class="col d-none">
      <div class="btn-group">
        <button type="button"
                class="btn btn-light dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
          <small><span class="glyphicon glyphicon-sort"></span>&nbsp;Sort</small>
        </button>
        <div class="dropdown-menu">
          <li class="dropdown-item"
              *ngFor="let item of sortOptions"
              [ngClass]="{'active': (sortType$|async)===item}"
              (click)='changeSort(item)'>
            {{item.label}}</li>
        </div>
      </div>
    </div>
    <div class="col">
      <button appSpinner
              [isLoading]="isLoading"
              type=""
              class="ui-btn text-success"
              (click)='download()'>
        <span class="fa fa-upload"></span>Download ({{totalOrders$|async}})
      </button>
    </div>
    <div class='col d-none'>
      <div id="floatContainer"
           class="float-container-">
        <label for="rangeDates"
               class='dropdown-label'><small>Date Range</small>
          <p-calendar id="rangeDates"
                      inputId="range_date"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="dateRange"
                      inputId='dateRange'
                      overlayVisible='true'
                      hideOnDateTimeSelect="false"
                      yearRange="2000:2030"
                      selectionMode="range"
                      [monthNavigator]="true"
                      [yearNavigator]="true"
                      [readonlyInput]="true"
                      [showButtonBar]="true"
                      #calendar
                      (onClickOutside)="onRangeChange()"
                      dateFormat="dd-mm-yy"
                      (onClose)="onRangeChange()"
                      (onClearClick)="onRangeChange()">
            <p-footer>
              <button class="btn btn-primary btn-small"
                      (click)="onRangeChange();calendar.hideOverlay()">Ok</button>
            </p-footer>
          </p-calendar>
        </label>
      </div>
    </div>
    <div class="col form-inline my-2 my-lg-0 d-none">
      <input type="text"
             class="form-control"
             pInputText
             size="30"
             placeholder="Search Orders"
             formControlName="farmer_name" />
      <span type='submit'
            class="ui-dropdown-filter-icon pi pi-search"
            style="margin-inline-start: -30px;"></span>
    </div>
  </nav>
</form>
